import React from "react"
import { useLocation } from "react-router-dom"
import StudentNavItem from "./StudentNavItem"
import { studentNavItems } from "./config/studentNavItems"
import { isStudentNavActive } from "./utils/isStudentNavActive"
import "./StudentBottomNav.style.scss"

const StudentBottomNav = () => {
  const { pathname } = useLocation()

  return (
    <nav className="student-bottom-nav" aria-label="Student mobile navigation">
      <div className="student-bottom-nav__inner">
        {studentNavItems.map((item) => (
          <StudentNavItem
            key={item.path}
            {...item}
            active={isStudentNavActive(pathname, item.path)}
            variant="bottom"
          />
        ))}
      </div>
    </nav>
  )
}

export default StudentBottomNav
